var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1003 5.39985C10.3932 5.69274 10.3932 6.16761 10.1003 6.46051L4.56066 12.0002L10.1003 17.5398C10.3932 17.8327 10.3932 18.3076 10.1003 18.6005C9.80744 18.8934 9.33256 18.8934 9.03967 18.6005L2.96967 12.5305C2.82902 12.3899 2.75 12.1991 2.75 12.0002C2.75 11.8013 2.82902 11.6105 2.96967 11.4698L9.03967 5.39985C9.33256 5.10695 9.80744 5.10695 10.1003 5.39985Z",
    fill: "#ECD06C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91992 12C2.91992 11.5858 3.25571 11.25 3.66992 11.25H20.4999C20.9141 11.25 21.2499 11.5858 21.2499 12C21.2499 12.4142 20.9141 12.75 20.4999 12.75H3.66992C3.25571 12.75 2.91992 12.4142 2.91992 12Z",
    fill: "#ECD06C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/sliderArrow.e2aca3fff2a952cf3147a493b337df2a.svg";
export { ForwardRef as ReactComponent };